import * as React from "react";
const SvgSuggestion20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M12.052 1.833a2.129 2.129 0 0 0-3.02.698L6.426 7H1v11h12a3 3 0 0 0 3-3v-3.5h1.25a2.75 2.75 0 1 0 0-5.5H13V3.604c0-.712-.356-1.376-.948-1.771ZM6 16V9H3v7h3Zm2 0h5a1 1 0 0 0 1-1V9.5h3.25a.75.75 0 0 0 0-1.5H11V3.604a.129.129 0 0 0-.24-.065L8 8.27V16Z",
      clipRule: "evenodd"
    })
  );
export default SvgSuggestion20Px;
